module.exports = __webpack_public_path__ + "media/images/captive_portal/iptv_ads-50de72867ce33a527aa08cfcf6a21637.svg";